import React from 'react'
import { Color } from '../../../utils/constants'

interface HeaderContextProps {
  isHeaderHovered: boolean
  setIsHeaderHovered: (isHovered: boolean) => void
  headerColor: Color
  headerHeight: number
}

const defaultValue: HeaderContextProps = {
    isHeaderHovered: false,
    setIsHeaderHovered: () => undefined,
    headerColor: Color.WHITE,
    headerHeight: 0,
}

const HeaderContext = React.createContext(defaultValue)
export const HeaderContextProvider = HeaderContext.Provider
export default HeaderContext
